import { Logger } from 'loglevel';
import { UserInfos } from '../types/UserInfos';
import { ENV } from '../config/env';

const apiBaseUrl = ENV.BACK_EDI_URL;

export class EdiUserAccountService {
  constructor(
    private readonly getAccessToken: () => Promise<string>,
    private readonly logger: Logger,
  ) {}

  async fetchUserConnectInfos(): Promise<UserInfos> {
    this.logger.debug('🚀 UserInfos context fetch request');

    const accessToken = await this.getAccessToken();
    const apiFetchUrl = `${apiBaseUrl}/api/CommonSSO/GetConnectInfos`;

    const response = await fetch(apiFetchUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    this.logger.info('📥 Response UserInfos context fetch:', {
      url: response.url,
      status: response.status,
      headers: Object.fromEntries(response.headers.entries()),
    });

    if (!response.ok) {
      const errorText = await response.text();
      this.logger.warn('Error details:', {
        status: response.status,
        statusText: response.statusText,
        errorText,
      });
      throw new Error(
        `Failed to fetch UserInfos: Status ${response.status} - ${response.statusText}`,
      );
    }

    const data: UserInfos = await response.json();

    return data;
  }
}
